export default __webpack_public_path__ + "static/media/Rectangle 2578.7f2dbe11.jpg";